export const isVariantField = (name: string): boolean =>
  /(\d+)-variant/.test(name)
